import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useMemo } from "react";

import { useFeatureFlags } from "./useFeatureFlags";

export function useDocumentAI() {
  const { featureFlags } = useFeatureFlags();
  return useMemo(() => featureFlags?.[FeatureFlagKey.DocumentAI] ?? false, [featureFlags]);
}
